import {
  getListWorkspace,
  getWorkspace,
  getWorkspacePage,
  onAddCardWorkspace,
  onCreateWorkspace,
  onDeleteCardWorkspace,
  onDeleteWorkspace,
  onSwithWorkspace,
  onUpdateWorkspace,
  onUpdateWorkspaceStatus,
} from "services/apis/workspace";
import snakecaseKeys from "snakecase-keys";
import { listenFirestoreWorkspaceEvent } from "useFirebase/useFireStore";

import { getMe } from "./auth";

const {
  createSlice,
  createSelector,
  createAsyncThunk,
} = require("@reduxjs/toolkit");

export const doGetWorkspaceEvent = createAsyncThunk(
  "workspace/doGetWorkspaceEvent",
  async (params, { dispatch }) => {
    const { workspaceId } = params;
    await listenFirestoreWorkspaceEvent(workspaceId, dispatch);
  }
);

export const doGetWorkspacePage = createAsyncThunk(
  "workspace/doGetWorkspacePage",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    Object.keys(request).forEach(
      k =>
        (request[k] =
          typeof request[k] == "string"
            ? request[k].trim().replaceAll(/"/g, '"').replaceAll(/\\/g, "\\\\")
            : request[k])
    );
    const result = await getWorkspacePage(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return result;
  }
);

export const doGetListWorkspace = createAsyncThunk(
  "workspace/doGetListWorkspace",
  async () => {
    const result = await getListWorkspace();
    if (!result) {
      return;
    }
    return result;
  }
);

export const getWorkspaceInfo = createAsyncThunk(
  "workspace/getWorkspaceInfo",
  async params => {
    const result = await getWorkspace(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const createWorkspace = createAsyncThunk(
  "workspace/createWorkspace",
  async (params, { dispatch }) => {
    const result = await onCreateWorkspace(params);
    if (!result) {
      return;
    }
    dispatch(getMe());
    return result;
  }
);

export const updateWorkspace = createAsyncThunk(
  "workspace/updateWorkspace",
  async (params, { dispatch }) => {
    const result = await onUpdateWorkspace(params);
    if (!result) {
      return;
    }
    dispatch(getWorkspaceInfo(params.id));
    return result;
  }
);

export const doAddCardWorkspace = createAsyncThunk(
  "workspace/doAddCardWorkspace",
  async params => {
    const result = await onAddCardWorkspace(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doDeleteCardWorkspace = createAsyncThunk(
  "workspace/doDeleteCardWorkspace",
  async id => {
    const result = await onDeleteCardWorkspace(id);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doSwitchWorkspace = createAsyncThunk(
  "workspace/doSwitchWorkspace",
  async params => {
    const result = await onSwithWorkspace(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doDeleteWorkspace = createAsyncThunk(
  "workspace/doDeleteWorkspace",
  async id => {
    const result = await onDeleteWorkspace(id);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doUpdateWorkspaceStatus = createAsyncThunk(
  "workspace/doUpdateWorkspaceStatus",
  async params => {
    const result = await onUpdateWorkspaceStatus(params.id, {
      status: params.status,
    });
    if (!result) {
      return;
    }
    return result;
  }
);

const initialState = {
  isSaving: false,
  workspaceList: [],
  workspacePage: {},
  workspaceDetail: {},
  workspace: {},
  numberOfElements: 0,
};

const slice = createSlice({
  name: "workspace",
  initialState: initialState,
  reducers: {
    setWorkspace: (state, action) => {
      state.workspace = action.payload;
    },
    setNumberOfElements: (state, action) => {
      state.numberOfElements = action.payload;
    },
    setCardToken: (state, action) => {
      state.cardToken = action.payload;
    },
  },
  extraReducers: {
    [doGetListWorkspace.pending]: state => {
      state.isSaving = true;
    },
    [doGetListWorkspace.fulfilled]: (state, action) => {
      state.workspaceList = action.payload;
      state.isSaving = false;
    },
    [doGetListWorkspace.rejected]: state => {
      state.workspaceList = [];
      state.isSaving = false;
    },
    [getWorkspaceInfo.fulfilled]: (state, action) => {
      state.workspaceDetail = action.payload;
    },
    [updateWorkspace.pending]: state => {
      state.isSaving = true;
    },
    [updateWorkspace.fulfilled]: state => {
      state.isSaving = false;
    },
    [updateWorkspace.rejected]: state => {
      state.isSaving = false;
      state.workspaceDetail = {};
    },
    [doSwitchWorkspace.pending]: state => {
      state.isSaving = true;
    },
    [doSwitchWorkspace.fulfilled]: state => {
      state.isSaving = false;
    },
    [doSwitchWorkspace.rejected]: state => {
      state.isSaving = false;
    },
    [createWorkspace.pending]: state => {
      state.isSaving = true;
    },
    [createWorkspace.fulfilled]: state => {
      state.isSaving = false;
    },
    [createWorkspace.rejected]: state => {
      state.isSaving = false;
    },
    [doAddCardWorkspace.pending]: state => {
      state.isSaving = true;
    },
    [doAddCardWorkspace.fulfilled]: state => {
      state.isSaving = false;
    },
    [doAddCardWorkspace.rejected]: state => {
      state.isSaving = false;
    },
    [doGetWorkspacePage.pending]: state => {
      state.isSaving = true;
      state.workspacePage = {};
    },
    [doGetWorkspacePage.fulfilled]: (state, action) => {
      state.isSaving = false;
      state.workspacePage = action.payload;
    },
    [doGetWorkspacePage.pending]: state => {
      state.isSaving = false;
      state.workspacePage = {};
    },
  },
});

const { reducer, actions } = slice;
const { setNumberOfElements } = actions;
export const { setWorkspace } = actions;

export default reducer;

export const isSaving = createSelector(
  state => state.workspace.isSaving,
  isSaving => isSaving
);

export const WorkspaceInfo = createSelector(
  state => state.workspace.workspaceDetail,
  workspaceDetail => workspaceDetail
);

export const WorkspaceList = createSelector(
  state => state.workspace.workspaceList,
  workspaceList => workspaceList
);

export const numOfEls = createSelector(
  state => state.workspace.numberOfElements,
  numberOfElements => numberOfElements
);

export const getRealtimeWorkspace = createSelector(
  state => state.workspace.workspace,
  workspace => workspace
);

export const fetchWorkspacePage = createSelector(
  state => state.workspace.workspacePage,
  workspacePage => workspacePage
);
